import { useState, useEffect, useCallback } from 'react'
import { appsyncQuery } from '../../api/appsync-client.js'

const GET_NOTES = `
  query GetReflectionPrivateNotes($reflectionId: ID!, $ownerUserId: ID) {
    getReflectionPrivateNotes(reflectionId: $reflectionId, ownerUserId: $ownerUserId) {
      text updatedAt
    }
  }
`

const UPDATE_NOTES = `
  mutation UpdateReflectionPrivateNotes($reflectionId: ID!, $ownerUserId: ID, $text: String!) {
    updateReflectionPrivateNotes(reflectionId: $reflectionId, ownerUserId: $ownerUserId, text: $text) {
      text updatedAt
    }
  }
`

export function useReflectionPrivateNotes({ reflectionId, ownerUserId = null, enabled = true } = {}) {
  const [notes, setNotes] = useState({ text: '', updatedAt: null })
  const [loading, setLoading] = useState(false)

  const load = useCallback(async () => {
    if (!enabled || !reflectionId) return
    setLoading(true)
    try {
      const data = await appsyncQuery(GET_NOTES, { reflectionId, ownerUserId })
      setNotes(data.getReflectionPrivateNotes || { text: '', updatedAt: null })
    } catch {
      // Private notes are optional; swallow errors
    } finally {
      setLoading(false)
    }
  }, [reflectionId, ownerUserId, enabled])

  useEffect(() => { load() }, [load])

  const updateNotes = useCallback(async (text) => {
    const data = await appsyncQuery(UPDATE_NOTES, { reflectionId, ownerUserId, text })
    setNotes(data.updateReflectionPrivateNotes)
    return data.updateReflectionPrivateNotes
  }, [reflectionId, ownerUserId])

  return { notes, loading, updateNotes, reload: load }
}
